import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ExpandArrowDownIcon } from '../../../../global/icons/icons';
import { WEBSITE_BUILDER_BACK_TEXT } from '../../../event-hubs.text';
import './website-builder-back-button.scss';

type WebsiteBuilderBackButtonProps = {
    onClick: () => void;
};

export const WebsiteBuilderBackButton = ({ onClick }: WebsiteBuilderBackButtonProps) => {
    return (
        <button className='website-builder-back-button' onClick={onClick}>
            <ExpandArrowDownIcon className='website-builder-back-button__arrow' />
            <span className='website-builder-back-button__label'>
                <FormattedMessage {...WEBSITE_BUILDER_BACK_TEXT} />
            </span>
        </button>
    );
};
